import { render, staticRenderFns } from "./securityCode.vue?vue&type=template&id=0a08cdac&lang=pug&"
import script from "./securityCode.vue?vue&type=script&lang=js&"
export * from "./securityCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports